var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import './polyfills/Function';
import * as React from 'react';
import * as RuntimeOptions from './RuntimeOptions';
import render from './render';
import AppContainer from './AppContainer';
import isClassComponent from './utils/isClassComponent';
import { AppLifecycle, callbackName, appEvents } from './lifecycle';
import AppInstanceContext from './AppInstanceContext';
import { ForwardRef } from './ReactIs';
var DefaultAppComponent = /** @class */ (function (_super) {
    __extends(DefaultAppComponent, _super);
    function DefaultAppComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultAppComponent.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.props.children);
    };
    return DefaultAppComponent;
}(React.Component));
export default function createAppConfig(App) {
    var WrappedApp = RuntimeOptions.get('pluginDriver').onAppComponent(App);
    var createConfig = function (AppComponent) {
        if (AppComponent === void 0) { AppComponent = DefaultAppComponent; }
        var config = {
            _container: new AppContainer(),
            _pages: [],
            _instance: React.createRef(),
            onLaunch: function (options) {
                this._container.context = this;
                this._render();
                return this.callLifecycle(AppLifecycle.launch, options);
            },
            callLifecycle: function (lifecycle) {
                var _a;
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                var callbacks = AppInstanceContext.lifecycleCallback[lifecycle] || [];
                var result;
                callbacks.forEach(function (callback) {
                    result = callback.apply(void 0, __spread(args));
                });
                if (result) {
                    return result;
                }
                var callback = callbackName(lifecycle);
                if (this._instance.current && this._instance.current[callback]) {
                    return (_a = this._instance.current)[callback].apply(_a, __spread(args));
                }
            },
            _mount: function (pageInstance) {
                /**
                 * 飞书开发者工具的问题，这里的 this 跟 getApp 拿到的不是同一个实例
                 */
                if (!this._container.context) {
                    this._container.context = this;
                }
                this._pages.push(pageInstance);
                this._render();
            },
            _unmount: function (pageInstance) {
                this._pages.splice(this._pages.indexOf(pageInstance), 1);
                this._render();
            },
            _render: function () {
                var props = {};
                if (isClassComponent(AppComponent) || AppComponent.$$typeof === ForwardRef) {
                    props.ref = this._instance;
                }
                return render(React.createElement(AppComponent, props, this._pages.map(function (p) { return p.element; })), this._container);
            },
            onShow: function (options) {
                return this.callLifecycle(AppLifecycle.show, options);
            },
            onHide: function () {
                return this.callLifecycle(AppLifecycle.hide);
            },
            onError: function (error) {
                return this.callLifecycle(AppLifecycle.error, error);
            },
            // 微信
            onPageNotFound: function (options) {
                return this.callLifecycle(AppLifecycle.pageNotFound, options);
            },
            // 微信
            onUnhandledRejection: function (options) {
                return this.callLifecycle(AppLifecycle.unhandledRejection, options);
            },
            // 微信
            onThemeChange: function (options) {
                return this.callLifecycle(AppLifecycle.themeChange, options);
            },
        };
        var lifecycleEvent = {
            // 阿里
            onShareAppMessage: function (options) {
                return this.callLifecycle(AppLifecycle.shareAppMessage, options);
            },
        };
        appEvents().forEach(function (eventName) {
            if (lifecycleEvent[eventName]) {
                config[eventName] = lifecycleEvent[eventName];
            }
        });
        return RuntimeOptions.get('pluginDriver').onAppConfig(config);
    };
    return createConfig(WrappedApp);
}
